import React from 'react'
import Moldes2 from "../../imagens/moldes/molde2.png"
import Moldes5 from "../../imagens/moldes/molde5.png"
import Moldes7 from "../../imagens/moldes/molde7.png"
import Moldes8 from "../../imagens/moldes/molde8.png"
import Moldes9 from "../../imagens/moldes/molde9.png"
import Moldes10 from "../../imagens/moldes/molde10.png"
import Moldes11 from "../../imagens/moldes/molde11.png"
import Moldes12 from "../../imagens/moldes/molde12.JPG"
import Moldes13 from "../../imagens/moldes/molde13.JPG"
import Moldes14 from "../../imagens/moldes/molde14.JPG"
import Moldes15 from "../../imagens/moldes/molde15.JPG"
import Moldes16 from "../../imagens/moldes/molde16.JPG"
import Moldes17 from "../../imagens/moldes/molde17.JPG"
import Moldes18 from "../../imagens/moldes/molde18.JPG"
import Moldes19 from "../../imagens/moldes/molde19.JPG"
import Moldes20 from "../../imagens/moldes/molde20.JPG"
import Moldes21 from "../../imagens/moldes/molde21.JPG"
import Moldes22 from "../../imagens/moldes/molde22.JPG"

import Header from '../../Components/Header'
import MoldesCapabilities from '../../Components/moldesCapabilities'

const moldesList = [
    {
        img: Moldes10
    },
    {
        img: Moldes11
    },
    {
        img: Moldes5
    },
    {
        img: Moldes7
    },
    {
        img: Moldes9
    },
    {
        img: Moldes2
    },

    {
        img: Moldes8
    },
    {
        img: Moldes12
    },
    {
        img: Moldes13
    },
    {
        img: Moldes14
    },
    {
        img: Moldes15
    },
    {
        img: Moldes16
    },
    {
        img: Moldes17
    },
    {
        img: Moldes18
    },
    {
        img: Moldes19
    },
    {
        img: Moldes20
    },
    {
        img: Moldes21
    },
    {
        img: Moldes22
    },

]



const MoldPage = () => {
    return (
        <div>
            <Header />
            <MoldesCapabilities
                moldesList={moldesList}
            />
        </div>
    )
}

export default MoldPage



